
import { languages } from "@/i18n";
import { defineComponent } from "vue";
import LogoVue from "../ui/Logo.vue";

export default defineComponent({
  components: {
    appLogo: LogoVue,
  },

  watch: {
    "$i18n.locale"(val) {
      localStorage.setItem("locale", val);
    },
  },

  data() {
    return { languages: [...languages] };
  },
});
